import { Link } from "react-router-dom";

import useStyles from "./pet-shop.styles";

const PetShopPage = ({ petTypePath }: { petTypePath: string }) => {
  const classes = useStyles();

  return (
    <div className={classes.petShopContainer}>
      <div className={classes.petShopTitle}>
        {`THE ${petTypePath.replaceAll("-", " ").toUpperCase()} SHOP`}
        <div className={classes.petShopImage}>
          {petTypePath.replaceAll("-", " ").toUpperCase()} Image
        </div>
      </div>
      <div className={classes.petShopBody}>
        <div className={classes.petShopLeftSection}>
          <Link to={`/shop/pet/${petTypePath}/food`}>Food</Link>
          <Link to={`/shop/pet/${petTypePath}/treats`}>Treats</Link>
          <Link to={`/shop/pet/${petTypePath}/toys`}>Toys</Link>
          <Link to={`/shop/pet/${petTypePath}/healthcare`}>Healthcare</Link>
          <Link to={`/shop/pet/${petTypePath}/vitamins`}>Vitamins</Link>
          <Link to={`/shop/pet/${petTypePath}/cleaning`}>Cleaning</Link>
        </div>
        <div className={classes.petShopRightSection}>
          <div className={classes.petShopSubContainer}>
            <div className={classes.petShopSubContainerTitle}>
              <span>Food</span>
              <Link to={`/shop/pet/${petTypePath}/food`}>Shop All</Link>
            </div>
            <div className={classes.petShopSubContainerLinks}>
              <Link to={`/shop/pet/${petTypePath}/food/dryfood`}>
                <div />
                Dry Food
              </Link>
              <Link to={`/shop/pet/${petTypePath}/food/wetfood`}>
                <div />
                Wet Food
              </Link>
              <Link to={`/shop/pet/${petTypePath}/food/rawfood`}>
                <div />
                Raw Food
              </Link>
              <Link to={`/shop/pet/${petTypePath}/food/frozenfood`}>
                <div />
                Frozen Food
              </Link>
            </div>
          </div>
          <div className={classes.petShopSubContainer}>
            <div className={classes.petShopSubContainerTitle}>
              <span>Treats</span>
              <Link to={`/shop/pet/${petTypePath}/treats`}>Shop All</Link>
            </div>
            <div className={classes.petShopSubContainerLinks}>
              <Link to={`/shop/pet/${petTypePath}/treats/biscuitstreats`}>
                <div />
                Biscuits Treats
              </Link>
              <Link to={`/shop/pet/${petTypePath}/treats/softtreats`}>
                <div />
                Soft Treats
              </Link>
              <Link to={`/shop/pet/${petTypePath}/treats/dentaltreats`}>
                <div />
                Dental Treats
              </Link>
              <Link to={`/shop/pet/${petTypePath}/treats/jerky`}>
                <div />
                Jerky
              </Link>
            </div>
          </div>
          <div className={classes.petShopSubContainer}>
            <div className={classes.petShopSubContainerTitle}>
              <span>Toys</span>
              <Link to={`/shop/pet/${petTypePath}/toys`}>Shop All</Link>
            </div>
            <div className={classes.petShopSubContainerLinks}>
              <Link to={`/shop/pet/${petTypePath}/toys/chewtoys`}>
                <div />
                Chew Toys
              </Link>
              <Link to={`/shop/pet/${petTypePath}/toys/plushtoys`}>
                <div />
                Plush Toys
              </Link>
              <Link to={`/shop/pet/${petTypePath}/toys/fetchtoys`}>
                <div />
                Fetch Toys
              </Link>
              <Link to={`/shop/pet/${petTypePath}/toys/tugtoys`}>
                <div />
                Tug Toys
              </Link>
            </div>
          </div>
          <div className={classes.petShopSubContainer}>
            <div className={classes.petShopSubContainerTitle}>
              <span>Healthcare</span>
              <Link to={`/shop/pet/${petTypePath}/healthcare`}>Shop All</Link>
            </div>
            <div className={classes.petShopSubContainerLinks}>
              <Link to={`/shop/pet/${petTypePath}/healthcare/skincare`}>
                <div />
                Skin Care
              </Link>
              <Link to={`/shop/pet/${petTypePath}/healthcare/dentalcare`}>
                <div />
                Dental Care
              </Link>
              <Link to={`/shop/pet/${petTypePath}/healthcare/jointcare`}>
                <div />
                Joint Care
              </Link>
              <Link to={`/shop/pet/${petTypePath}/healthcare/earcare`}>
                <div />
                Ear Care
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PetShopPage;
